@if (effectivenessModel && stepPermissions) {
    <eff-workflow-status
        [workFlowSteps]="workFlowSteps"
    ></eff-workflow-status>

    <eff-detail-breadcrumb-info
        [effectivenessModel]="effectivenessModel"
    ></eff-detail-breadcrumb-info>

    @switch (currentPage) {
        @case (pageTypes.UploadSourceDocuments) {
            @if (stepPermissions.canViewSourceDocuments) {
                <eff-testing-upload-source-document
                    class="eff-step-page"
                    [cerrixTab]="cerrixTab"
                    [effectivenessModel]="effectivenessModel"
                    [stepPermissions]="stepPermissions"
                    [pageState]="currentPageState"
                ></eff-testing-upload-source-document>
            }
        }
        @case (pageTypes.UploadEvidence) {
            <eff-testing-upload-evidence
                class="eff-step-page"
                [cerrixTab]="cerrixTab"
                [effectivenessModel]="effectivenessModel"
                [stepPermissions]="stepPermissions"
                [pageState]="currentPageState"
            ></eff-testing-upload-evidence>
        }
        @case (pageTypes.Test) {
            <eff-testing-test
                class="eff-step-page"
                [cerrixTab]="cerrixTab"
                [effectivenessModel]="effectivenessModel"
                [stepPermissions]="stepPermissions"
                [pageState]="currentPageState"
                [showReviewColumn]="showReviewColumn"
            ></eff-testing-test>
        }
        @case (pageTypes.Review) {
            <eff-testing-review
                class="eff-step-page"
                [cerrixTab]="cerrixTab"
                [effectivenessModel]="effectivenessModel"
                [stepPermissions]="stepPermissions"
                [pageState]="currentPageState"
            ></eff-testing-review>
        }
        @case (pageTypes.Completed) {
            <eff-testing-completed
                class="eff-step-page"
                [cerrixTab]="cerrixTab"
                [effectivenessModel]="effectivenessModel"
                [stepPermissions]="stepPermissions"
                [showReviewColumn]="showReviewColumn"
            ></eff-testing-completed>
        }
    }
}
